import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import RichTextView from "@/components/app/RichTextView";
import AttachmentList from "@/components/app/AttachmentList";

export default function ProjectDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/projects/${id}`).then((r) => setItem(r.data)).catch(() => setError("Not found"));
  }, [id]);

  if (error) return <div className="mx-auto max-w-3xl px-4 py-20 text-center text-stone-600">Project not found.</div>;
  if (!item) return <div className="mx-auto max-w-3xl px-4 py-20 text-center text-stone-500">Loading…</div>;

  return (
    <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
      <Link to="/projects" className="inline-flex items-center gap-1 text-sm text-stone-600 hover:text-stone-900">
        <ArrowLeft className="h-4 w-4" /> Back to projects
      </Link>
      <article className="mt-6 rounded-3xl border border-stone-200 bg-white p-6 sm:p-10 shadow-sm">
        <div className="text-xs font-mono uppercase tracking-widest text-[#b45309]">
          {item.date ? new Date(item.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : ""}
        </div>
        <h1 className="mt-2 font-serif text-4xl font-semibold text-stone-900">{item.headline}</h1>
        <RichTextView html={item.body} className="mt-6 text-lg" />
        {item.attachments?.length > 0 && (
          <div className="mt-8" data-testid="project-attachments">
            <AttachmentList attachments={item.attachments} testidPrefix="project-attachment" />
          </div>
        )}
      </article>
    </div>
  );
}
